import React from "react";
import {
    Box, Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormLabel,
    Input,
    Radio,
    RadioGroup,
    Typography
} from "@mui/material";
import TextField from "@mui/material/TextField";
import {useResolvedPath} from "react-router-dom";
import {useMutation} from "react-query";
import {toast} from "react-toastify";
import ApiClient from "../../API";


export default function AddBroadcastForm({toggle}) {
    const currentPath = useResolvedPath()
    const [title, setTitle] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [validUntil, setValidUntil] = React.useState('');
    const [validFrom, setValidFrom] = React.useState('');
    const [locationTags, setLocationTags] = React.useState([
        currentPath.pathname
    ]);

    const selectedLocationRadio = locationTags.length > 0 ? 'selected' : 'all';

    const mutation = useMutation((data) => {
        const postPromise = ApiClient().post('/broadcast/', data);
        return toast.promise(postPromise, {
            pending: 'Adding Broadcast...',
            success: 'Broadcast Added Successfully',
            error: 'Failed to Add Broadcast'
        })
    }, {
        onSuccess: () => {
            setTitle('');
            setMessage('');
            setValidFrom('');
            setValidUntil('');
            setLocationTags([currentPath.pathname]);
            toggle();
        },
        retry: 1,
    })

    return (
        <Box component="form" noValidate autoComplete="off" className="p-5">
                    <h5>Add Broadcast</h5>


            <Input
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                fullWidth
                sx={{marginBottom: 2}}
            />
            <TextField
                type={"textarea"}
                placeholder="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
                sx={{marginBottom: 2}}
            />

            <Typography>Broadcast Notification Validity (optional)</Typography>
            <FormControl>
                <FormLabel>Valid From</FormLabel>
                <Input type={"datetime-local"}
                       placeholder="Valid From"
                       value={validFrom}
                       onChange={(e) => setValidFrom(e.target.value)}
                       fullWidth
                       sx={{marginBottom: 2}}
                />
            </FormControl>
            <FormControl>
                <FormLabel>Valid Until</FormLabel>
                <Input type={"datetime-local"}
                       placeholder="Valid Until"
                       value={validUntil}
                       onChange={(e) => setValidUntil(e.target.value)}
                       fullWidth
                       sx={{marginBottom: 2}}
                />
            </FormControl>
            <br/>


            <FormControl>
                <FormLabel>Visible on</FormLabel>
                <RadioGroup
                    defaultValue="all"
                    name="locationTags"
                    value={selectedLocationRadio}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === 'all') {
                            setLocationTags([]);
                        } else {
                            // Logic to handle selected locations
                            // This could be a modal or a multi-select component to choose locations
                            setLocationTags([currentPath.pathname]); // Example static data
                        }
                    }}
                >
                    <FormControlLabel
                        value="all"
                        control={<Radio/>}
                        label="All Locations"/>
                    <FormControlLabel
                        value="selected"
                        control={<Radio/>}
                        label="Selected Locations"/>
                </RadioGroup>
            </FormControl>
            <FormControl>

                <FormControlLabel
                    control={<Checkbox/>} label={"Dashboard Menu"} value={"/dashboard"}
                    checked={locationTags.length > 0 && locationTags.includes("/dashboard")}
                    onChange={(e) => {
                        const value = "/dashboard";
                        setLocationTags((prev) => {
                            if (value && !prev.includes(value)) {
                                return [...prev, value];
                            } else {
                                return prev.filter(tag => tag !== value);
                            }
                        });
                    }}
                    disabled={selectedLocationRadio === "all"}/>
                <FormControlLabel
                    title={currentPath?.pathname}
                    control={<Checkbox/>} label={"Current Location"} value={currentPath?.pathname}
                    checked={locationTags.length > 0 && locationTags.includes(currentPath?.pathname)}
                    onChange={(e) => {
                        const value = currentPath?.pathname;
                        setLocationTags((prev) => {
                            if (value && !prev.includes(value)) {
                                return [...prev, value];
                            } else {
                                return prev.filter(tag => tag !== value);
                            }
                        });
                    }}
                    disabled={selectedLocationRadio === "all" || !currentPath?.pathname || currentPath?.pathname === "/dashboard"}/>

            </FormControl>

            <br/>

            <Button variant="contained" color="primary" onClick={() => {
                mutation.mutate({
                    title,
                    message,
                    valid_from: validFrom,
                    valid_until: validUntil,
                    location_tags: locationTags
                });
            }} disabled={mutation.isLoading || !title || !message}>
                Create Broadcast
            </Button>

        </Box>
    )
}